import { render, staticRenderFns } from "./DemjanProjekt.vue?vue&type=template&id=96e7e2a4&scoped=true&"
import script from "./DemjanProjekt.vue?vue&type=script&lang=js&"
export * from "./DemjanProjekt.vue?vue&type=script&lang=js&"
import style0 from "./DemjanProjekt.vue?vue&type=style&index=0&id=96e7e2a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e7e2a4",
  null
  
)

export default component.exports